import React from 'react';
import GlobalPlayerConsumer from './GlobalPlayerConsumer';
import AudioPlayer from '../../utility/AudioPlayer/AudioPlayer.jsx';
import './globalplayer.scss';

const GlobalPlayer = props => {
  return (
    <div className="p-4 d-flex align-items-center justify-content-center w-100 position-fixed global-player-container">
      <AudioPlayer source={props.source} />
    </div>
  );
};

const GlobalPlayerRoot = () => (
  <GlobalPlayerConsumer>
    {props => (props.playing ? <GlobalPlayer {...props} /> : null)}
  </GlobalPlayerConsumer>
);

export default GlobalPlayerRoot;
